import React, { useEffect, useState } from "react";
import "./Category.css";
import { NavLink, useNavigate } from "react-router-dom";
import { Icon } from "react-icons-kit";
import { trash } from "react-icons-kit/feather/trash";
import { eye } from "react-icons-kit/feather/eye";
import { arrowUpRight } from "react-icons-kit/feather/arrowUpRight";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import { DeleteStore, GetStore, api_url } from "../apiconfig/authService";
import { Pagination } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { RiLoaderFill } from "react-icons/ri";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";

function Store(props) {
  const navigate = useNavigate();
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const [sliderData, setSliderData] = useState([]);
  const [totalSliders, setTotalSliders] = useState(0);
  const [recordIdToDelete, setRecordIdToDelete] = useState("");
  const [refetchData, setRefetchData] = useState(false);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [loading, setLoading] = useState(false);

  // Infinite scroll state
  const [hasMore, setHasMore] = useState(true);

  const handlePerPageRecordsChange = (e) => {
    setItemsPerPage(e.target.value);
    setPage(1);
    setSliderData([]);
    setHasMore(true);
  };

  const formatUTCDate = (utcDateString) => {
    const date = new Date(utcDateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} at ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const limit = itemsPerPage === "all" ? 50 : itemsPerPage;

        const sliderResponse = await GetStore(
          page,
          limit,
          search,
          localStorage.getItem("accessToken")
        );

        if (itemsPerPage === "all") {
          if (page === 1) {
            setSliderData(sliderResponse.data.items);
          } else {
            setSliderData((prev) => [...prev, ...sliderResponse.data.items]);
          }

          if (sliderResponse.data.items.length === 0) {
            setHasMore(false);
          }

          setTotalSliders(sliderResponse.data.pagination.count);
        } else {
          setSliderData(sliderResponse.data.items);
          setPageCount(Math.ceil(sliderResponse.data.pagination.pageCount));
          setTotalSliders(sliderResponse.data.pagination.count);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [page, itemsPerPage, refetchData]);

  const handleDeleteSliderClick = async (storeid) => {
    try {
      setLoading(true);
      setSearch("");
      await DeleteStore(storeid, localStorage.getItem("accessToken"));
      setRefetchData((prev) => !prev);
      toast.success("Store Deleted Successfully!");
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewSliderClick = (storeid) => {
    navigate(`/viewStore/${storeid}`);
  };

  const handleEditSliderClick = (storeid) => {
    navigate(`/editStore/${storeid}`);
  };

  const handleSearchBoxSubmit = (event) => {
    event.preventDefault();
    setPage(1);
    setSliderData([]);
    setHasMore(true);
    setRefetchData(!refetchData);
  };

  const fetchMoreData = () => {
    setPage((prev) => prev + 1);
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">
            Store Management
            <br />
            <small className="text-primary h6 fw-bold">
              Total counts {totalSliders}
            </small>
          </h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/addStore" className="btn btn-primary addSeller">
              Add Store
            </NavLink>
          </div>
        </div>

        <div className="searchList row">
          <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
            <span className="h6 mb-0">Display Records</span>
            <select
              className="form-select"
              value={itemsPerPage}
              onChange={handlePerPageRecordsChange}
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
              {sliderData.length > 500 && <option value="all">All</option>}
            </select>
          </div>
          <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
            <form className="sForm" onSubmit={handleSearchBoxSubmit}>
              <input
                type="text"
                onChange={(event) => {
                  setSearch(event.target.value);
                }}
                className="form-control form-control-lg w-100"
                id="s"
                placeholder="Search"
              />
            </form>
          </div>
        </div>

        {loading && page === 1 ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill size={40} className="text-success spin-animation" />
          </div>
        ) : itemsPerPage === "all" ? (
          <InfiniteScroll
            dataLength={sliderData.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <div className="d-flex align-items-center justify-content-center">
                <RiLoaderFill
                  size={30}
                  className="text-success spin-animation"
                />
              </div>
            }
            endMessage={
              <p className="text-center text-muted">No more stores to show.</p>
            }
          >
            <div className="table-responsive">
              <table className="table table-borderless table-hover">
                <thead>
                  <tr>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "50px",
                      }}
                      scope="col"
                      width="45"
                      align="center"
                    >
                      <div className="selectAll">
                        <input className="form-check-input" type="checkbox" />
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "80px",
                      }}
                      scope="col"
                      width="80"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">SR.</span>
                        <button className="filtBtn idFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Store Name</span>
                        <button className="filtBtn fNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Image</span>
                        <button className="filtBtn fNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Web Url</span>
                        <button className="filtBtn fNameFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Support Url</span>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Support Image</span>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Created By</span>
                        <button className="filtBtn statusFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Modified By</span>
                        <button className="filtBtn statusFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Created Date</span>
                        <button className="filtBtn statusFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "200px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Modified Date</span>
                        <button className="filtBtn emailFilter"></button>
                      </div>
                    </th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: "150px",
                      }}
                      scope="col"
                    >
                      <div className="tableHeadItems position-relative">
                        <span className="text-ellipsis">Action</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {sliderData?.map((item, index) => (
                    <tr key={item._id}>
                      <td>
                        <input className="form-check-input" type="checkbox" />
                      </td>
                      <td>{index + 1}</td>
                      <td>{item.storename}</td>
                      <td>
                        <img
                          width="50px"
                          height="50px"
                          src={`${api_url}/product/category/getCategoryImage/${item.image}`}
                          alt="store"
                        />
                      </td>
                      <td>
                        {item?.weburl !== "-"
                          ? item?.weburl?.slice(0, 30) + "..."
                          : item?.weburl}
                      </td>
                      <td>{item?.supporturl}</td>
                      <td>
                        <img
                          width="50px"
                          height="50px"
                          src={`${api_url}/product/category/getCategoryImage/${item?.supportimage}`}
                          alt="support"
                        />
                      </td>
                      <td>{formatUTCDate(item?.createdDate)}</td>
                      <td>{formatUTCDate(item?.modifyDate)}</td>
                      <td>
                        <div className="d-grid gap-2 d-md-block">
                          <button
                            type="button"
                            onClick={() => handleViewSliderClick(item?.storeid)}
                            className="actBtn viewBtn"
                          >
                            <Icon className="eye" icon={eye} size={18} />
                            <span className="toolTip">Preview</span>
                          </button>
                          <button
                            type="button"
                            onClick={() => handleEditSliderClick(item?.storeid)}
                            className="actBtn editBtn"
                          >
                            <Icon
                              className="arrowUpRight"
                              icon={arrowUpRight}
                              size={18}
                            />
                            <span className="toolTip">Edit</span>
                          </button>
                          <button
                            onClick={() => setRecordIdToDelete(item?.storeid)}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            type="button"
                            className="actBtn delBtn"
                          >
                            <Icon className="trash" icon={trash} size={18} />
                            <span className="toolTip">Delete</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </InfiniteScroll>
        ) : (
          <div className="table-responsive">
            <table className="table table-borderless table-hover">
              <thead>
                <tr>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "50px",
                    }}
                    scope="col"
                    width="45"
                    align="center"
                  >
                    <div className="selectAll">
                      <input className="form-check-input" type="checkbox" />
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "80px",
                    }}
                    scope="col"
                    width="80"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">SR.</span>
                      <button className="filtBtn idFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Store Name</span>
                      <button className="filtBtn fNameFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Image</span>
                      <button className="filtBtn fNameFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Web Url</span>
                      <button className="filtBtn fNameFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Support Url</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Support Image</span>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Created By</span>
                      <button className="filtBtn statusFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Modified By</span>
                      <button className="filtBtn statusFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Created Date</span>
                      <button className="filtBtn statusFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "200px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Modified Date</span>
                      <button className="filtBtn emailFilter"></button>
                    </div>
                  </th>
                  <th
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      minWidth: "150px",
                    }}
                    scope="col"
                  >
                    <div className="tableHeadItems position-relative">
                      <span className="text-ellipsis">Action</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="table-group-divider">
                {sliderData?.map((item, index) => (
                  <tr key={item._id}>
                    <td>
                      <input className="form-check-input" type="checkbox" />
                    </td>
                    <td>{index + 1}</td>
                    <td>{item.storename}</td>
                    <td>
                      <img
                        width="50px"
                        height="50px"
                        src={`${api_url}/product/category/getCategoryImage/${item?.image}`}
                        alt="store"
                      />
                    </td>
                    <td>
                      {item?.weburl !== "-"
                        ? item?.weburl?.slice(0, 30) + "..."
                        : item?.weburl}
                    </td>
                    <td>{item?.supporturl}</td>
                    <td>
                      <img
                        width="50px"
                        height="50px"
                        src={`${api_url}/product/category/getCategoryImage/${item?.supportimage}`}
                        alt="support"
                      />
                    </td>
                    <td>{item?.createdBy}</td>
                    <td>{item?.modifyBy}</td>
                    <td>{formatUTCDate(item?.createdDate)}</td>
                    <td>{formatUTCDate(item?.modifyDate)}</td>
                    <td>
                      <div className="d-grid gap-2 d-md-block">
                        <button
                          type="button"
                          onClick={() => handleViewSliderClick(item?.storeid)}
                          className="actBtn viewBtn"
                        >
                          <Icon className="eye" icon={eye} size={18} />
                          <span className="toolTip">Preview</span>
                        </button>
                        <button
                          type="button"
                          onClick={() => handleEditSliderClick(item?.storeid)}
                          className="actBtn editBtn"
                        >
                          <Icon
                            className="arrowUpRight"
                            icon={arrowUpRight}
                            size={18}
                          />
                          <span className="toolTip">Edit</span>
                        </button>
                        <button
                          onClick={() => setRecordIdToDelete(item?.storeid)}
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                          type="button"
                          className="actBtn delBtn"
                        >
                          <Icon className="trash" icon={trash} size={18} />
                          <span className="toolTip">Delete</span>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination section (hidden for infinite scroll) */}
        {itemsPerPage !== "all" && !loading && (
          <div className="resultList pt-3 border-top">
            <div className="row">
              <div className="d-flex justify-content-between displayRecord col mb-2">
                {totalSliders === 0 ? (
                  <div>Showing 0 - 0 of 0 entries.</div>
                ) : (
                  <div>
                    Showing {(page - 1) * itemsPerPage + 1} -{" "}
                    {totalSliders < itemsPerPage * page
                      ? totalSliders
                      : itemsPerPage * page}{" "}
                    of {totalSliders} entries.
                  </div>
                )}
                <div>
                  <Pagination
                    prev
                    last
                    next
                    first
                    size="sm"
                    ellipsis
                    boundaryLinks
                    onSelect={setPage}
                    limit={Number(itemsPerPage)}
                    onChangeLimit={setItemsPerPage}
                    layout={["pager", "skip"]}
                    pages={pageCount}
                    total={totalSliders}
                    maxButtons={5}
                    activePage={page}
                    onChangePage={(page) => {
                      setPage(page);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Delete confirmation modal */}
        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="10"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body text-center p-5">
                <h1
                  className="modal-title display-6 mb-4"
                  id="exampleModalLabel"
                >
                  Proceed with delete?
                </h1>
                <button
                  type="button"
                  className="btn btn-danger me-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => handleDeleteSliderClick(recordIdToDelete)}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Store;
